module.exports = __webpack_public_path__ + "img/no-paike.43c9331b.png";